/* Ability Warehouse — product page member box when the membership is already in the cart.
   The section renders that case "locked" (no tick box). This runs before pdp.js (deferred, in <head>) and turns it into a
   ticked box instead: unticking removes the membership and the member code from the cart, ticking adds them back — the
   same as the cart. Signed-in members (customer tag, data-member="true") and no-sale products stay as they are. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp]');
  if (!root || root.dataset.noSale === 'true' || root.dataset.member === 'true' || root.dataset.locked !== 'true') return;

  root.dataset.locked = 'false'; /* pdp.js now treats the box as a normal, ticked box */
  root.setAttribute('data-mem-cart', 'on');
  var APPLIED = '✓ Member price applied';
  var css = document.createElement('style');
  css.textContent = '[data-pdp][data-mem-cart] [data-under]{display:none!important}.pdp-mb.is-busy{opacity:.75;pointer-events:none;cursor:progress}';
  document.head.appendChild(css);

  function addBox(label, attr, cls) {
    if (!label || label.querySelector('input')) return null;
    label.classList.remove('is-locked');
    var input = document.createElement('input');
    input.type = 'checkbox'; input.checked = true; input.setAttribute(attr, '');
    input.setAttribute('aria-label', 'Membership is in your cart. Untick to remove it and pay the normal price');
    var box = document.createElement('span'); box.className = cls; box.setAttribute('aria-hidden', 'true');
    label.insertBefore(box, label.firstChild); label.insertBefore(input, box);
    return input;
  }
  var panel = root.querySelector('[data-member-panel]');
  var tog = addBox(panel, 'data-tog-input', 'pdp-mb__bx');
  addBox(root.querySelector('[data-bar-m]'), 'data-bar-tog', 'pdp-bar__bx');
  if (!tog) return;

  /* Captions: while the membership is in the cart and the box is ticked, say "Member price applied" (pdp.js would say "Added") */
  var inCart = true;
  function fixCaps() {
    var on = inCart && tog.checked;
    root.setAttribute('data-mem-cart', on ? 'on' : 'off');
    [root.querySelector('[data-mb-cap]'), root.querySelector('[data-bar-r]')].forEach(function (el) {
      if (el && on && el.textContent !== APPLIED) el.textContent = APPLIED;
    });
  }
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(fixCaps);
    [root.querySelector('[data-mb-cap]'), root.querySelector('[data-bar-r]')].forEach(function (el) { if (el) mo.observe(el, { childList: true, characterData: true, subtree: true }); });
  }

  function postCart(url, body) {
    var C = window.CWCart; if (C && C.sections) body.sections = C.sections();
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not update your cart'); return j; }); })
      .then(function (j) { var C2 = window.CWCart; return (C2 && C2.apply && j && j.sections) ? Promise.resolve(C2.apply(j.sections)) : null; });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function setCartMembership(on) {
    var job = function () {
      return getCart().then(function (c) {
        var lines = (c.items || []).filter(function (i) { return i.handle === 'membership'; });
        if (on) {
          var item = { id: +root.dataset.mv, quantity: 1, properties: { Promo: root.dataset.freeMonth === 'true' ? '2 months free membership' : 'First month free' } };
          if (+root.dataset.plan) item.selling_plan = +root.dataset.plan;
          return (lines.length ? Promise.resolve() : postCart('/cart/add.js', { items: [item] }))
            .then(function () { return postCart('/cart/update.js', { discount: root.dataset.code || 'NEWMEMBER' }); });
        }
        var updates = {}; lines.forEach(function (l) { updates[l.key] = 0; });
        return postCart('/cart/update.js', { updates: updates, discount: '' });
      });
    };
    var C = window.CWCart;
    return C && C.enqueue ? C.enqueue(job) : job();
  }
  var reverting = false;
  tog.addEventListener('change', function () {
    if (reverting) return;
    var on = tog.checked;
    inCart = on;
    setTimeout(fixCaps, 0); /* after pdp.js has re-rendered */
    setCartMembership(on).catch(function (err) {
      inCart = !on; tog.checked = !on;
      reverting = true; tog.dispatchEvent(new Event('change', { bubbles: true })); reverting = false; /* let pdp.js repaint the prices */
      alert(err.message || 'Sorry, your cart could not be updated. Please try again.');
    });
  });
  document.addEventListener('DOMContentLoaded', function () { setTimeout(fixCaps, 0); });
})();
